import { format } from "date-fns"

export function getDateInstring(date) {
    const splited = date?.split("=")
    return `${format(new Date(splited[1]?.split("&")[0]), 'dd-MMM-yyyy')} à ${format(new Date(splited[2]), 'dd-MMM-yyyy')}`
} 